import {
  constants,
  mediaQueryStyles,
  typographyStyles,
} from "@newsela/angelou";
const { mediaQuery } = mediaQueryStyles;
const { sm } = constants.breakpoints.BreakpointNames;

const { colors } = constants;
const { fontSize } = typographyStyles;

export const imageCss = {
  borderRadius: "0 85px 0 0",

  [mediaQuery.downTo(sm)]: {
    borderRadius: "0 100px 0 0",
  },
};

export const figureCss = {
  margin: "0",
  width: "100%",
  height: "100%",
};

export const captionCss = [
  fontSize.textXS,
  {
    color: colors.ui.neutral[400],
    paddingTop: "1.2rem",
  },
];
